<app-abstract-dialog class="confirmation-dialog"
                     [dialogWidth]="'800'"
                     [playButtonActive]="true"
                     [ttsIconState]="ttsIconState"
                     [repeatButtonActive]="repeatButtonActive"
                     (readTextEvent)="readText()"
                     (playAudioEvent)="playAudio()"
                     (closeEvent)="onClose()">

    <ng-container abstract-header>
        <mat-icon class="abstract-dialog__header__icon material-icons-round error">
            delete
        </mat-icon>
        <h3 class="abstract-dialog__header__title">{{dialogTitle}}</h3>
    </ng-container>

    <ng-container abstract-content>
        <p class="abstract-dialog__content__text" [innerHTML]="dialogDescription"></p>
    </ng-container>

    <ng-container abstract-footer>
        <div class="abstract-dialog__footer__buttons-wrapper">
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'small outlined outlined__gray-07'"
                        [ariaLabel]="('GENERAL.CANCEL' | translate) + ('GENERAL.BUTTON' | translate)"
                        (buttonClicked)="onClose()">
                    {{'GENERAL.CANCEL' | translate }}
                </app-button>
            </div>
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'small solid__blue-07'"
                        [ariaLabel]="('GENERAL.DELETE' | translate) + ('GENERAL.BUTTON' | translate)"
                        (buttonClicked)="onDelete()">
                    {{'GENERAL.DELETE' | translate }}
                </app-button>
            </div>
        </div>
    </ng-container>
</app-abstract-dialog>
